(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimori-gorros-saten"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mimori-bonnets'))customElements.define('mimori-bonnets',class extends HTMLElement{
 connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';
 const form=this.querySelector('form.mlp-form'),buy=this.querySelector('[data-buy]'),sticky=this.querySelector('[data-sticky-buy]'),rows=[...this.querySelectorAll('[data-quantity-row]')],status=this.querySelector('.mlp-status');
 const money=cents=>'$'+(cents/100).toLocaleString('es-UY',{maximumFractionDigits:2});
 const sync=()=>{let quantity=0,subtotal=0,valid=true;for(const row of rows){const input=row.querySelector('[data-quantity]'),id=row.querySelector('[data-variant]'),n=Number(input.value),max=input.dataset.available==='false'?0:input.max===''?Infinity:Number(input.max);const good=Number.isInteger(n)&&n>=0&&n<=max;valid=valid&&good;id.disabled=n===0||!good;input.disabled=max===0;row.querySelector('[data-step="-1"]').disabled=n<=0||max===0;row.querySelector('[data-step="1"]').disabled=n>=max;if(good){quantity+=n;subtotal+=n*Number(input.dataset.price);}}
 const saving=0,total=subtotal,detail=quantity+' '+(quantity===1?'artículo':'artículos');
 this.querySelector('[data-sticky-price]').textContent=this.querySelector('[data-order-total]').textContent=money(total);this.querySelector('[data-quantity-summary]').textContent=detail;
 const savingLabel=this.querySelector('[data-saving]');savingLabel.hidden=saving===0;savingLabel.textContent='Ahorrás '+money(saving)+' · '+money(quantity?total/quantity:0)+' cada uno';
 buy.disabled=sticky.disabled=!valid||quantity===0;buy.textContent=quantity>0&&valid?'COMPRAR AHORA · '+money(total):'ELEGÍ LA CANTIDAD';sticky.textContent=quantity>0&&valid?'COMPRAR AHORA':'ELEGÍ LA CANTIDAD';status.textContent=!valid?'La cantidad supera el stock disponible o no es válida.':quantity===0?'Elegí al menos un artículo.':'';return valid&&quantity>0;};
 for(const row of rows){const input=row.querySelector('[data-quantity]');row.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{input.value=String(Math.max(0,Math.min(input.max===''?Infinity:Number(input.max),(Number(input.value)||0)+Number(button.dataset.step))));sync();}));input.addEventListener('input',sync);input.addEventListener('change',sync);}
 const root=(this.dataset.root||'/').replace(/\/?$/, '/');
let busy=false;
const returnKey='mimori-checkout:'+form.id;
const remember=()=>{this.returning=true;try{sessionStorage.setItem(returnKey,'1');}catch{}};
const forget=()=>{this.returning=false;try{sessionStorage.removeItem(returnKey);}catch{}};
const isReturning=()=>{try{return this.returning||sessionStorage.getItem(returnKey)==='1';}catch{return this.returning;}};
const purchaseControls=[...this.querySelectorAll('[data-quantity],[data-step],[data-buy],[data-sticky-buy]')];
const lock=()=>{busy=true;form.setAttribute('aria-busy','true');purchaseControls.forEach(el=>el.disabled=true);};
const unlock=()=>{busy=false;form.removeAttribute('aria-busy');sync();};
const request=async(path,body)=>{
 const response=await fetch(root+path,{method:body===undefined?'GET':'POST',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body===undefined?{}:{'Content-Type':'application/json'})},...(body===undefined?{}:{body:JSON.stringify(body)})});
 const data=await response.json();
 if(!response.ok)throw new Error(typeof data.description==='string'?data.description:'No pudimos actualizar el pedido. Intentá nuevamente.');
 return data;
};
const selected=()=>rows.map(row=>({id:row.querySelector('[data-variant]').value,quantity:Number(row.querySelector('[data-quantity]').value)})).filter(item=>item.quantity>0);
const quantities=items=>{const result=new Map();for(const item of items){const id=String(item.variant_id||item.id);result.set(id,(result.get(id)||0)+item.quantity);}return result;};
const matches=(cart,items)=>{const expected=quantities(items),actual=quantities(cart.items);return expected.size===actual.size&&[...expected].every(([id,n])=>actual.get(id)===n);};
form.addEventListener('submit',async e=>{
 e.preventDefault();
 if(busy||!sync()||!form.reportValidity())return;
 const items=selected();lock();buy.textContent=sticky.textContent='PREPARANDO PEDIDO…';status.textContent='Actualizando tu selección…';
 try{
  let cart=await request('cart.js');
  if(!matches(cart,items)){
   await request('cart/clear.js',{});
   await request('cart/add.js',{items});
   cart=await request('cart.js');
  }
  if(!matches(cart,items))throw new Error('El carrito cambió. Revisá las cantidades y volvé a intentar.');
  remember();window.location.assign(root+'cart?view=mimori');
 }catch(error){unlock();status.textContent=error.message||'No pudimos preparar el pedido. Intentá nuevamente.';}
});
const refreshFromCart=async()=>{
 if(!isReturning())return;
 lock();status.textContent='Actualizando las cantidades de tu pedido…';
 try{
  const cart=await request('cart.js'),actual=quantities(cart.items);
  for(const row of rows){const input=row.querySelector('[data-quantity]');input.value=String(actual.get(row.querySelector('[data-variant]').value)||0);}
  forget();unlock();
 }catch{unlock();status.textContent='No pudimos consultar el carrito. Revisá tu selección antes de comprar.';}
};
this.onPageShow=()=>{if(isReturning())refreshFromCart();else if(!busy)sync();};
window.addEventListener('pageshow',this.onPageShow);
sync();
if(isReturning())refreshFromCart();

 const bar=this.querySelector('.mlp-sticky');this.observer=new ResizeObserver(()=>this.style.setProperty('--mlp-sticky-height',bar.getBoundingClientRect().height+'px'));this.observer.observe(bar);
 const track=this.querySelector('.mlp-track'),slides=[...this.querySelectorAll('.mlp-slide')],controls=this.querySelector('.mlp-gallery-controls'),count=this.querySelector('[data-slide-count]');controls.hidden=slides.length<2;const current=()=>Math.round(track.scrollLeft/track.clientWidth);const move=delta=>track.scrollTo({left:((current()+delta+slides.length)%slides.length)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});this.querySelector('[data-prev]').onclick=()=>move(-1);this.querySelector('[data-next]').onclick=()=>move(1);count.textContent='1 / '+slides.length;track.addEventListener('scroll',()=>count.textContent=(current()+1)+' / '+slides.length,{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
 }disconnectedCallback(){this.observer?.disconnect();window.removeEventListener('pageshow',this.onPageShow);delete this.dataset.ready;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimori-labios"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mimori-lips'))customElements.define('mimori-lips',class extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;this.dataset.ready='true';
  const form=this.querySelector('.mlp-form');
  const button=this.querySelector('[data-buy]');
  const sync=()=>{const selected=form.querySelector('input[name="id"]:checked');const available=selected?.dataset.available==='true';button.disabled=!available;const sticky=this.querySelector('[data-sticky-buy]');if(sticky){sticky.disabled=!available;sticky.textContent=available?button.dataset.label:button.dataset.unavailable;}button.textContent=available?button.dataset.label+' · '+selected.dataset.price:button.dataset.unavailable;this.querySelector('[data-sticky-price]').textContent=selected.dataset.price;this.querySelector('[data-main-price]').textContent=selected.dataset.price;this.querySelector('[data-pack-detail]').textContent=selected.dataset.packDetail;};
  form.addEventListener('change',sync);
  form.addEventListener('submit',event=>{if(button.disabled){event.preventDefault();return;}button.setAttribute('aria-busy','true');});
  sync();
  const bar=this.querySelector('.mlp-sticky');
  this.barObserver=new ResizeObserver(()=>this.style.setProperty('--mlp-sticky-height',bar.getBoundingClientRect().height+'px'));
  this.barObserver.observe(bar);
  const track=this.querySelector('.mlp-track');
  const slides=Array.from(this.querySelectorAll('.mlp-slide'));
  const count=this.querySelector('[data-slide-count]');
  if(track){this.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('.mlp-slide');const index=slides.indexOf(slide);if(index>=0)track.scrollTo({left:index*track.clientWidth,behavior:'instant'});});}
  if(track && slides.length>1){
   const current=()=>Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
   const move=delta=>{const index=(current()+delta+slides.length)%slides.length;track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
   this.querySelector('[data-prev]').addEventListener('click',()=>move(-1));
   this.querySelector('[data-next]').addEventListener('click',()=>move(1));
   track.addEventListener('scroll',()=>{count.textContent=(current()+1)+' / '+slides.length;},{passive:true});
   track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
  }
 }
 disconnectedCallback(){this.barObserver?.disconnect();delete this.dataset.ready;}
});

  } catch(e) { console.error(e); }
})();
})();
